import React from 'react';
import { Constants } from "@eagerdog/constants";

import { apiService } from "src/services";
import { toast } from "src/components/Toast/ToastManager";
import { Modal, useModal } from "src/components/Modal/Modal";
import Confirm from "src/components/Confirm/Confirm";
import CancelRegistrationModal from "./CancelRegistrationModal";

import styles from "./UserWaitlistTab.module.scss";

interface IProps {
  entry: any;
  onChanged(): void;
}

export const CancelRenderer = (props: IProps) => {
  const { isShown: isWithdrawShown, toggle: toggleWithdraw } = useModal();
  const { isShown: isCancelShown, toggle: toggleCancel } = useModal();

  const w = props.entry;

  if (!w) return null;

  const status = w.status;
  const isCourseKind = w.entry_kind === "course" || w.entry_kind === "class" || w.entry_kind === "seminar";
  const isRegistered =
    status === Constants.waitlist_status.registered ||
    status === Constants.waitlist_status.refund_denied;
  const isWaitlist = status === Constants.waitlist_status.waitlist;

  if (isCourseKind && !isWaitlist) return null;
  if (!isRegistered && !isWaitlist) return null;

  return (
    <div className={styles.CancelRenderer}>
      <button
        className={styles.cancelBtn}
        onClick={() => (isWaitlist ? toggleWithdraw() : toggleCancel())}
      >
        {isWaitlist ? "Withdraw" : "Request Refund / Cancel"}
      </button>

      {/* Waitlist withdraw confirm */}
      <Modal
        className="confirmModal"
        isShown={isWithdrawShown}
        hide={toggleWithdraw}
        modalContent={
          <Confirm
            message={
              <p>
                Are you sure you want to withdraw <strong>{w.call_name}</strong> from {isCourseKind ? w.event?.title : `${w.show_type} ${w.show_name}`}?
                You'll be removed from the waitlist and lose your current position.
              </p>
            }
            onConfirm={() => {
              const request = isCourseKind
                ? apiService.leaveCourseWaitlist(w.event_id, w._id)
                : apiService.cancelUserWaitlistEntry(w._id);
              request.then(() => {
                toast.show({
                  title: "Waitlist Withdraw",
                  content: `You've successfully withdrawn from ${w.show_type} ${w.show_name}`,
                  duration: 10000,
                  type: "success",
                });
                props.onChanged();
              }).catch((e: any) => {
                toast.show({
                  title: "Waitlist Withdraw",
                  content: e.response?.data?.message ?? "Something went wrong, please try again later",
                  duration: 10000,
                  type: "fail",
                });
              });
              toggleWithdraw();
            }}
            onCancel={() => toggleWithdraw()}
          />
        }
      />

      {/* Cancel registered entry modal */}
      {isCancelShown && (
        <Modal
          className="cancelRegistrationModal"
          isShown={isCancelShown}
          hide={toggleCancel}
          modalContent={
            <CancelRegistrationModal
              entry={{
                show_registration_id: w.show_registration_id ?? w._id,
                call_name: w.call_name,
                show_type: w.show_type,
                show_name: w.show_name,
                show_date: w.show_date,
                show_element: w.dog_class?.show_element ?? "",
                level: w.dog_class?.level,
                section: w.dog_class?.section,
                entry_fee: w.entry_fee ?? null,
                entry_platform_fee: w.entry_platform_fee ?? null,
                transaction_id: w.transaction_id ?? null,
                stripe_payment_intent_id: w.stripe_payment_intent_id ?? null,
              }}
              onSuccess={() => {
                toggleCancel();
                props.onChanged();
              }}
              onCancel={() => toggleCancel()}
            />
          }
        />
      )}
    </div>
  );
};
